import { css } from 'lit'


export const style = css`
  :host {
    display: block;
  }

  .toast-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .toast-item {
    display: block;
    width: fit-content;
  }

  .toast-item + .toast-item {
    margin-top: var(--cse-space-03, 0.75rem);
  }

  .toast-item.is-exiting {
    pointer-events: none;
  }
`

